import { AppBox, AppText } from "../../../../commons/components";
import { FootballOrganizer } from "../../../../commons/models/football/football-organizer";
import { toTitleCase } from "../../../../commons/utilities/string-utils";

interface OrganizerDeleteProps {
  organizer: FootballOrganizer;
}
export default function OrganizerDeleteInprogress({ organizer }: OrganizerDeleteProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Deleting <strong>“{toTitleCase(organizer.name)}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
